{
  "app.locale": "English (United States)",
  "product.lms": "LMS",
  "product.ems": "EMS",
  "field": "field | fields",
  "action": "action | actions"
}
